import { arrayOf } from 'prop-types';
import React from 'react';

import Table from '../../generic/Table';
import {
  associatedAgreementShape,
  reactTableColumnShape,
} from '../../prop-types';
import { listColumns } from '../agreement-columns';
import AgreementRow from './AgreementRow';

function AgreementsTable({ agreements, columns }) {
  return (
    <Table
      className="c-table-with-subcomponent no-overflow"
      data={agreements}
      columns={columns}
      minRows={1}
      SubComponent={row => <AgreementRow agreementId={row.original.id} />}
    />
  );
}

AgreementsTable.propTypes = {
  agreements: arrayOf(associatedAgreementShape.isRequired).isRequired,
  columns: arrayOf(reactTableColumnShape),
};

AgreementsTable.defaultProps = {
  columns: listColumns,
};

export default AgreementsTable;
